export var CHAT_OPEN_CLASS = "edge-tier-chat-open";
export var ROOT_ID = "root";
export var SOCKET_NAMESPACE = "chat";
// Fallback language when a translation or something is missing.
export var DEFAULT_LANGUAGE_ID = 11;
//# sourceMappingURL=string-constants.js.map